import { MdCheck } from "react-icons/md";
import cx from "classnames";

interface Props {
  checked?: boolean;
}

export default function Checkbox({ checked = false }: Props) {
  const className = cx({
    Checkbox: true,
    "Checkbox--checked": checked,
  });

  return (
    <div className={className}>
      {checked ? <MdCheck size={16} color="#000" /> : null}
    </div>
  );
}
